import { useDialogContext } from '../../../contexts/DialogContext';
import { window } from '../../../globals';
import { getAuthorizeServiceURL } from '../../../helpers/services';
import { post } from '../../../redux/api';
import Icon, { icons } from '../../generic/Icon';

const GitlabSettings = () => {
  const { onConfirm } = useDialogContext();

  return (
    <div>
      <div className="text-center margin-bottom-sm">
        <h1>Gitlab Login</h1>
        <p>FOSSA allows users to link a Gitlab login to their FOSSA login.</p>
      </div>
      <div className="card">
        {!window.user.gitlab ? (
          <div className="service-connected-container">
            <h4>You are not connected to Gitlab</h4>
            <a
              href={getAuthorizeServiceURL({
                vcsHost: 'gitlab',
                location: window.location.href,
                serviceConnect: true,
              })}
              className="btn btn-service-connect">
              <Icon icon={icons.gitlab} />&nbsp;Connect to GitLab
            </a>
          </div>
        ) : (
          <div className="service-connected-container">
            <h4>
              You are currently connected{' '}
              {window.user.gitlab.name ? (
                <span>
                  as <b>{window.user.gitlab.name}</b>
                </span>
              ) : (
                <span>to GitLab</span>
              )}
            </h4>
            <button
              type="button"
              onClick={() => {
                onConfirm({
                  title: 'Confirm GitLab disconnect',
                  body: (
                    <div>
                      <p>
                        <b>Are you sure you want to disassociate the current user with the registered GitLab account?</b>{' '}
                        (cannot be undone)
                      </p>
                    </div>
                  ),
                  onConfirm: async () => {
                    await post('/api/services/gitlab/disconnectService', undefined);
                    window.location.reload();
                  },
                });
              }}
              className="btn btn-primary btn-service-login-disconnect">
              Disconnect
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GitlabSettings;
